import { api } from "./api";

export const enviarCalificacion = (cifEstudiante, idLibro, puntuacion) => {
  return api.post("/calificaciones/guardar", {
    cifEstudiante,
    idLibro,
    puntuacion,
  });
};

export const verificarCalificacion = async (cifEstudiante, idLibro) => {
  const { data } = await api.get("/calificaciones/yaCalificado", {
    params: { cifEstudiante, idLibro },
  });
  return data;
};

export const obtenerCalificacionDeUsuario = async (cifEstudiante, idLibro) => {
  const { data } = await api.get("/calificaciones/obtenerCalificacion", {
    params: { cifEstudiante, idLibro },
  });
  return data;
};
